<template>
	<div class="d3-generic">
		<svgicon :name="icon" :fill="false" :style="`width: ${scaled_value}px; height: ${scaled_value}px`"/>
	</div>
</template>

<script>
import * as d3 from '@/utils/d3'
const props = {
	value: {
		type: Number,
		default: 0
	},
	icon: {
		type: String,
		default: 'my idicare'
	},
	domain: {
		type: Object,
		default: () => ({
			min: 0,
			max: 100
		})
	}
}
export default {
	props,
	data () {
		return {
			width: 0,
			height: 0,
			padding: 20
		}
	},
	computed: {
		padded () {
			const width = Math.max(this.width - this.padding * 2, 0)
			const height = Math.max(this.height - this.padding * 2, 0)
			return { width, height }
		},
		scale () {
			const dimension = Math.min(this.padded.width, this.padded.height)
			return d3.scaleLinear()
				.domain([this.domain.min, this.domain.max])
				.range([50, dimension])
				.clamp(true)
		},
		scaled_value () {
			//return this.scale(this.value)
			return this.scale(this.domain.max) // make all icons max size
		}
	},
	methods: {
		onResize () {
			//console.log('D3Generic.onResize')
			this.width = Math.max(this.$el.offsetWidth, 0)
			this.height = Math.max(this.$el.offsetHeight, 0)
			this.update()
		},
		update () {

		}
	},
	mounted () {
		window.addEventListener('resize', this.onResize)
		this.$root.$on('force-render-biometric-measure', this.onResize)
		this.onResize()
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.onResize)
		this.$root.$off('force-render-biometric-measure', this.onResize)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/measure/D3Generic.vue